import { date } from "../../../utils/date";
import ChapterCard from "./ChapterCard";
import UnlockNextChapter from "./UnlockNextChapter";

export default function ChaptersList({trackName, chapters, enrolledAt, matchId, nextUnlocksDays, onClick, selected}) { 
    let daysAssigned = false

    return(<div className="flex columns gap-xs">
        {!chapters && <div className="dashed-card columns standard-padding">
            <p className="card-title">No Months</p>
            <p className="card-body">Please contact your superior.</p>
        </div>}
        {chapters && <>
            <div className="padding-xs left v-spacer-s">
                <p className="section-title medium">{trackName}</p>
                <p className="card-label neutral light">Started: <span className="medium">{date(enrolledAt ?? '')}</span></p>
            </div>
            <UnlockNextChapter anyLocked={chapters.some(it => it.isLocked)} matchId={matchId}/>
            {chapters?.filter(it => !it.isCompleted).map(chapter => {
                const unlocksNext = chapter.isLocked && !daysAssigned
                if (unlocksNext) daysAssigned = true
                return(<ChapterCard chapter={chapter} selectedId={selected?.id ?? ''} unlocksIn={unlocksNext ? nextUnlocksDays : undefined} onClick={onClick}/>)
            })}
            {chapters?.some(it => it.isCompleted) && <p className="neutral card-body hi-spacer-xs vi-spacer-m">Passed Months</p>}
            {chapters?.filter(it => it.isCompleted).map(chapter => <ChapterCard chapter={chapter} selectedId={selected?.id ?? ''} onClick={onClick}/>)}
        </>}
    </div>)
}
